export const ru = {
    title: 'Запрос доступа отклонен',
    description: 'Обратитесь к координатору вашей компании',
};
